import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@mono-repo/util';
import { LoadingIndicatorService } from '@mono-repo/loader';
import { MessageService, MessageType } from '@mono-repo/messages';
import { PageContainer } from '../../cockpit/_shared/page-container/page-container';
import { HeaderService } from '../../cockpit/_shared/header/header.service';
import { HttpClient } from '@angular/common/http';
import { BackendNode, OdataOperation, OdataService } from '@mono-repo/odata';
import { environment } from '../../../environments_mc';
import { SystemEnvironment } from '@mono-repo/data';

@Component({
  selector: 'app-migration',
  templateUrl: './migration.component.html',
})
export class MigrationComponent extends PageContainer implements OnInit {
  @HostBinding('class') class = 'dt-c-interactive-dialog';

  public emailForm: FormGroup; // think about this: using a formgroup for just one formcontrol is unnecassary
  public passwordRequested = false;
  public pageSubheading: string;

  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private odataService: OdataService,
    private loaderService: LoadingIndicatorService,
    headerService: HeaderService,
    translateService: TranslateService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
  ) {
    super(headerService, translateService);
  }

  ngOnInit() {
    this.setHeaderData({
      hideReporterButton: true,
    });
    this.setTranslateModule('migration');
    this.pageSubheading = this.translateService.translate('PAGE_SUBHEADING');

    this.emailForm = this.formBuilder.group({ email: ['', Validators.email] });
  }

  public backToLogin() {
    this.router.navigateByUrl('/');
  }

  public submitPasswordRequest() {
    this.loaderService.preactivateLoader();
    let baseUrl: string;
    switch (environment.systemEnvironment) {
      case SystemEnvironment.APP:
        baseUrl = environment.backend.publicUrl;
        break;

      case SystemEnvironment.CLOUD_NEO:
        baseUrl = environment.backend.mailingUrl;
        break;

      case SystemEnvironment.CLOUD_FOUNDRY:
        baseUrl = environment.backend.publicUrl;
        break;
      case SystemEnvironment.LOCALHOST:
        baseUrl = environment.backend.publicUrl;
    }
    //We have to rewrite baseUrl in cas off APP in Neo this is derived in a hacky way
    if(environment.systemEnvironment == SystemEnvironment.APP && environment.appConfiguration && !environment.appConfiguration.isOpenid ) {
      baseUrl = environment.backend.mailingUrl;
    }
    /*
    this.odataService.post<any>(new OdataOperation().Query('SendMailNewPasswordMigration'), { emailAddress: this.emailForm.value.email }, {
      overrideBackendNode: baseUrl,
    }).subscribe({
        next: () => {
          this.passwordRequested = true;
        },
        error: (error) => {
          this.messageService.add(error, MessageType.ERROR);
        },
    });
    */
    
    this.httpClient
      .post(baseUrl + '/SendMailNewPasswordMigration', { emailAddress: this.emailForm.value.email })
      .subscribe({
        next: () => {
          this.passwordRequested = true;
        },
        error: (error) => {
          this.messageService.add(error, MessageType.ERROR);
        },
      });
    
  }
}
